<template>
	<v-dialog v-model="dialog" persistent max-width="600px">
		<v-card :disabled="loading || removing">
			<v-card-title>
				<v-btn icon color="error" :loading="removing" v-if="event" class="mr-2" @click="remove()">
					<v-icon>mdi-delete-outline</v-icon>
				</v-btn>
				<span class="headline">{{ momentDate }}</span>
				<v-spacer></v-spacer>
				<v-btn icon @click="$emit('close', 'close')">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text>
				<v-form @keyup.native.enter="submit" v-model="valid" lazy-validation ref="form">
					<v-row>
						<v-col>
							<v-date-picker
								v-model="reqData.dates"
								first-day-of-week="1"
								full-width
								no-title
								range
								@click:date="prepareDates"
								:day-format="d => new Date(d).getDate()"
							></v-date-picker>
						</v-col>
					</v-row>

					<v-row>
						<v-col>
							<v-text-field v-model="reqData.name" :rules="rules" :label="$t('fields.name')" required></v-text-field>
						</v-col>
					</v-row>

					<v-row justify="space-between" align="center">
						<v-icon left>mdi-clock-outline</v-icon>
						<span>{{ getBeginTime(reqData.hours[0]) }} - {{ getEndTime(reqData.hours[1]) }}</span>
						<v-range-slider v-model="reqData.hours" :max="max" :min="min" hide-details />
					</v-row>
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="primary" @click="submit" :loading="loading">{{ $t('save') }}</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import slotsMixin from '~/mixins/slotsMixin'
export default {
	name: 'AddUpdate',

	mixins: [slotsMixin],

	props: {
		date: {
			type: String,
			default: null
		},
		event: {
			type: Object,
			default: null
		}
	},

	data() {
		return {
			reqData: {
				name: null,
				hours: [],
				dates: []
			},
			dialog: false,
			loading: false,
			removing: false,
			valid: true,
			rules: [
				v => !!v || this.$t('validation.field_is_required', { field: this.$t('fields.name') }),
				v => (v || '').length <= 50 || this.$t('max_char', { charCount: '50' })
			]
		}
	},

	computed: {
		momentDate() {
			if (this.reqData.dates.length === 1) {
				return this.$moment(this.reqData.dates[0]).format('D. MMMM YYYY')
			}

			if (this.reqData.dates.length === 2) {
				return this.$moment(this.reqData.dates[0]).format('D. MMMM YYYY') + ' - ' + this.$moment(this.reqData.dates[1]).format('D. MMMM YYYY')
			}

			return ''
		}
	},

	created() {
		this.reqData.hours = [this.min, this.max]

		if (this.event !== null) {
			this.reqData.dates =
				this.event.absence.begin_dt === this.event.absence.end_dt
					? [this.event.absence.begin_dt]
					: [this.event.absence.begin_dt, this.event.absence.end_dt]
			this.reqData.hours = [this.event.absence.begin_slot, this.event.absence.end_slot]
			this.reqData.name = this.event.absence.name
		} else {
			this.reqData.dates = [this.date]
		}

		this.dialog = true
	},

	methods: {
		prepareDates() {
			if (this.reqData.dates.length === 2) {
				this.reqData.dates.sort()
				if (this.reqData.dates[0] === this.reqData.dates[1]) {
					this.reqData.dates.pop()
				}
			}
		},
		async remove() {
			this.removing = true
			await this.$http.delete(`absence/${this.event.id}`)
			this.$emit('close', 'remove', this.event.id)
		},
		submit() {
			this.valid = this.$refs.form.validate()

			if (this.valid) {
				if (this.event) {
					this.update()
				} else {
					this.save()
				}
			}
		},
		async save() {
			this.loading = true
			let { data } = await this.$http.post('absence', this.reqData)
			this.$emit('close', 'add', data)
		},
		async update() {
			this.loading = true
			let { data } = await this.$http.patch(`absence/${this.event.id}`, this.reqData)
			this.$emit('close', 'update', data)
		}
	}
}
</script>

<style lang="scss" scoped></style>
